FAQMainView = require('./main')
FAQArticleView = require('./article')
FAQBreadCrumbView = require('./breadcrumb')
FAQTopicView = require('./topic')
FAQAutoCompleteView = require('./autocomplete')
SharedAjaxErrorView = require('../../../shared/frontend/views/ajax_error_view')
FAQV1AutoSuggestionListView = require('./v1_autosuggestionlist')
FAQV2AutoSuggestionListView = require('./v2_autosuggestionlist')
FAQContentModel = require('../models/content')
FAQHomeModel = require('../models/home')
FAQAutoSuggestionListView = require('./autosuggestionlist')
FAQTrendingArticlesView = require('./trendingArticles')
Backbone = require 'backbone'
Backbone.$ = $

class FAQViewManagerView extends Backbone.View
  initialize: ->
    _.bind(@renderErrorHtml, this)
    @faqContentContainer = $('#content-container')
    @errorContainer = $('#error-container')
    @spinner = $('.g-spinner')
    @contentModel = new FAQContentModel()
    @homeModel = new FAQHomeModel()
    @breadCrumbView = new FAQBreadCrumbView()
    @errorView = new SharedAjaxErrorView()
    @autoCompleteView = new FAQAutoCompleteView({
      'container' : $('#auto-complete-container')
    })
    @autoCompleteView.render()
    @renderTrendingArticles() if @isV2View()

  #renders the faq page
  render: (requestId)->
    $(window).scrollTop(0)
    splitIds = @splitRequestId(requestId)
    viewId = @findViewID(splitIds)
    @autoCompleteView.invalidate()
    @breadCrumbView.invalidate()
    @renderFooter()
    if viewId?
      @currentView.remove() if @currentView?
      switch viewId
        when FAQMainView.VIEWID then @constructFaqMainView()
        when FAQTopicView.VIEWID then @constructTopicView(splitIds[0])
        when FAQArticleView.VIEWID then @constructArticleView(splitIds[0], splitIds[1])
        when FAQAutoSuggestionListView.VIEWID then @constructAutoSuggestionListView(splitIds[1])
    else
      @renderErrorHtml({
        query : requestId
      })

  splitRequestId : (requestId) ->
    return requestId.split(window.ID_seperator)

  findViewID : (splitIds) ->
    return null unless splitIds?.length > 0
    baseId = splitIds[0]
    if splitIds.length is 1
      if(baseId is FAQMainView.VIEWNAME)
       return FAQMainView.VIEWID
      else
       return FAQTopicView.VIEWID
    else
      if(baseId is FAQAutoSuggestionListView.VIEWNAME)
        return FAQAutoSuggestionListView.VIEWID
      return FAQArticleView.VIEWID

  # renders the Faq Main page content
  constructFaqMainView :(topicId = null) ->
    @currentView = new FAQMainView({
      'breadCrumbView'  : @breadCrumbView
      'container'       : @faqContentContainer
      'errorContainer'  : @errorContainer
      'spinner'         : @spinner
      'homeModel'       : @homeModel
      'errorView'       : @errorView
      'topic'           : topicId
    })
    @currentView.render()
    if @isV2View()
      @hideFooter()
      if !topicId?
        scrollTo($('.contact-us'))

  renderTrendingArticles: ->
    @homeModel.fetch
      success: ( model, response, options ) =>
        stopTimer("t_fh")
        $('.trending-articles-container').show()
        trendingArticlesView = new FAQTrendingArticlesView(model: @homeModel)
        trendingArticlesView.render()
      error: ( model, xhr, options )  =>
        $('.trending-articles-container').hide()
        stopTimer("t_fh")

  renderFooter : ->
    $('.faq-footer').show()

  hideFooter: ->
    $('.faq-footer').hide()

  # renders the topic content
  constructTopicView :(topicId) ->
    if @isV2View()
      @constructFaqMainView(topicId)
    else
      @currentView = new FAQTopicView({
        'breadCrumbView'  : @breadCrumbView
        'contentModel'     : @contentModel
        'container'       : @faqContentContainer
        'errorContainer' : @errorContainer
        'spinner'         : @spinner
      })
      @currentView.render(topicId)

  # renders the Article content
  constructArticleView :(topicId, articleId)  ->
    @currentView = new FAQArticleView({
      'breadCrumbView'  : @breadCrumbView
      'contentModel'     : @contentModel
      'summarized'      : false
      'container'       : @faqContentContainer
      'errorContainer'  : @errorContainer
      'spinner'         : @spinner
    })
    @currentView.render(topicId, articleId)
    scrollTo($('.tabs-container')) if @isV2View()

  constructAutoSuggestionListView : (searchText) ->
    options = {
      'breadCrumbView'  : @breadCrumbView
      'container'       : @faqContentContainer
      'errorContainer'  : @errorContainer
      'spinner'         : @spinner
    }
    if @isV2View()
      @currentView = new FAQV2AutoSuggestionListView(options)
    else
      @currentView = new FAQV1AutoSuggestionListView(options)
    @currentView.render(searchText)

  isV2View: ->
    evaluate(experiments?.showVerticalPageFlow)

  scrollToFAQSearch: () ->
    scrollTo($('#faqs'))

  renderErrorHtml : (hash = {}) ->
    @breadCrumbView.invalidate()
    if hash.query?
      data =
        searchId  : hash.query
        text      : "#{I18n.t('js.modules.faq.search_result')}'#{hash.query}'"
      @breadCrumbView.addCrumbs(data)
    @breadCrumbView.render()
    @errorView.render(hash)
    @constructFaqMainView()
    @scrollToFAQSearch()

module.exports = FAQViewManagerView
